import React from 'react';
import PropTypes from 'prop-types';
import {i18n} from '../../Utility/Format';

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {query: '', result: [], selectedIndex: -1};

        this.reset = this.reset.bind(this);
        this.handleKey = this.handleKey.bind(this);
    }

    search(input) {
        let primaryResult = [];
        let secondaryResult = [];

        if (input && input.length > 0) {
            const s = input.toUpperCase();
            primaryResult = this.props.ccyPairs.filter((ccyPair) => {
                return ccyPair.indexOf(s) === 0;
            });

            secondaryResult = this.props.ccyPairs.filter((ccyPair) => {
                return ccyPair.indexOf(s) > 0;
            });
        }

        this.setState({query: input, result: primaryResult.concat(secondaryResult), selectedIndex: -1});
    }

    reset() {
        this.setState({query: '', result: []});
        return true;
    }

    getLabelFor(ccy) {
        const matches = this.props.currencies.filter((it) => {
            return it.isoString === ccy;
        });

        const match = matches[0];

        const label = this.props.language === 'de' ? match.label : match.labelEN
        return label || '-';
    }

    baseOf(ccyPair) {
        return ccyPair.substr(0,3);
    }

    counterOf(ccyPair) {
        return ccyPair.substr(3,3);
    }

    formatCcyPair(ccyPair) {
        return this.baseOf(ccyPair) + '_' + this.counterOf(ccyPair);
    }

    createResultList() {
        let list = this.state.result.map((it, index) => {
            let className = null;
            if (index === this.state.selectedIndex) {
                className = 'search_result__selected';
            }
            const currencyPair = this.formatCcyPair(it);
            return (
                <tr key={currencyPair}>
                    <td className={className}><a href="/#" onClick={(e) => { e.preventDefault(); this.props.onResultClick(currencyPair); }}>{it}</a></td>
                    <td style={{whiteSpace:'nowrap'}}>({this.getLabelFor(this.baseOf(it))}/{this.getLabelFor(this.counterOf(it))})</td>
                    <td style={{whiteSpace:'nowrap'}}>
                        <div onClick={this.props.onResultAdd.bind(null, currencyPair)} style={{fontSize: 'x-small', cursor: 'pointer'}}>
                            {i18n('dbm.stage.search.add.to.spot')}
                        </div>
                    </td>
                </tr>
            );
        });

        if (list.length > this.props.displayMaxResults) {
            list = list.slice(0, this.props.displayMaxResults);
            const more = (
                <tr key="more">
                    <td colSpan="2"><div>...</div></td>
                </tr>
            );
            list.push(more);
        }


        if (list.length > 0) {
            return <table className="search_result"><tbody>{list}</tbody></table>
        } else if(list.length === 0 && this.state.query !== '') {
            return <div className="search_result">{i18n('dbm.stage.search.no.result')}</div>
        } else {
            return null;
        }
    }

    handleKey(e) {
        if (this.state.result.length > 0) {
            if (e.key === 'Enter') {
                let selectedIndex = this.state.selectedIndex;
                if (selectedIndex < 0) {
                    selectedIndex = 0;
                }
                this.props.onResultClick(this.formatCcyPair(this.state.result[selectedIndex]));
                this.reset();
            } else if (e.key === 'ArrowDown') {
                let selectedIndex = this.state.selectedIndex;
                if (selectedIndex < this.state.result.length && selectedIndex < this.props.displayMaxResults) {
                    selectedIndex += 1;
                    this.setState({selectedIndex: selectedIndex});
                }
            } else if (e.key === 'ArrowUp') {
                let selectedIndex = this.state.selectedIndex;
                if (selectedIndex > 0) {
                    selectedIndex -= 1;
                    this.setState({selectedIndex: selectedIndex});
                }
            }
        }
    }

    render() {
        return (
             <div>
                 <div>
                    {i18n('dbm.stage.search')}
                    <input
                        className="textfield"
                        type="text"
                        style={{width: '6em'}}
                        placeholder="EURUSD"
                        value={this.state.query}
                        onChange={(e) => {this.search(e.target.value)}}
                        onKeyDown={this.handleKey}
                        onBlur={() => {setTimeout(() => {this.reset()}, 200)}} //Give it some time to handle a potential click in the result
                    />
                </div>
                <div>
                    {this.createResultList()}
                </div>
            </div>
        );
    }
}

Search.propTypes = {
    ccyPairs: PropTypes.array.isRequired,
    currencies: PropTypes.array.isRequired,
    language: PropTypes.string.isRequired,
    displayMaxResults: PropTypes.number,
    onResultClick: PropTypes.func,
    onResultAdd: PropTypes.func,
};

export default Search;